<template>
    <v-row>
        <template
            v-for="({ label, colorOption, icon, count }, index) in counts"
        >
            <v-col :key="`col-${index}`">
                <psi-stats-card
                    hide-actions
                    :title="label"
                    :stat="count"
                    :color-option="colorOption"
                    :icon="icon"
                ></psi-stats-card>
            </v-col>
        </template>
    </v-row>
</template>
<script>
import WithCrimeRecords from "@components/screen/mixins/WithCrimeRecords";
export default {
    name: "crime-summary",
    mixins: [WithCrimeRecords],
    components: {},
    props: {
        crimes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            counts: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.records = this.crimes;
        this.counts = this.getCounts();
    },
};
</script>

